import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PAYMENTS_MANUAL_BILL_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetManualBillPayload, GetManualBillResult, ManualBill } from '../types/getManualBill.types';

export const MANUAL_BILL = 'ManualBill';

export const getManualBill = (builder: BuilderType) =>
  builder.query<ManualBill, GetManualBillPayload>({
    providesTags: [MANUAL_BILL],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_PAYMENTS_MANUAL_BILL_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetManualBillResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return response.Result.ManualBill;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
